export default __webpack_public_path__ + "static/media/meanyme.0bd07449.png";